import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CbDasherModule, CbInfiniteScrollModule, CbInfoPopupModule } from 'cb-hub-lib';
import { CbInfoMessageModule } from 'cb-hub-lib';
import { CbLoadingSpinnerModule } from 'cb-hub-lib';
import { CbCurrencyModule } from '@app/shared/pipe/currency/currency.module';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CB_TABLE_EXPORTS } from './table/exports';

const COMPONENTS = [
    ...CB_TABLE_EXPORTS,
];

@NgModule({
    declarations: [
        COMPONENTS
    ],
    imports: [
        CommonModule,
        MatDividerModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonModule,
        CbInfoPopupModule,
        CbDasherModule,
        CbInfoMessageModule,
        CbCurrencyModule,
        MatSelectModule,
        MatCardModule,
        MatCheckboxModule,
        CbLoadingSpinnerModule,
        MatTableModule,
        InfiniteScrollDirective,
        CbInfiniteScrollModule,
    ],
    exports: COMPONENTS,
})
export class CbHubTableModule { }
